// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__Iz0j8","question":"styles_question__3oxtG","inputVisibleButton":"styles_inputVisibleButton__2qGsN","note":"styles_note__2iL_y"};